import { rem } from 'polished'
import React, { ReactNode } from 'react'
import styled from 'styled-components'
import Group from 'components/utils/Group'
import TextButton from 'components/Luxkit/Button/TextButton'
import LineTrashAltIcon from 'components/Luxkit/Icons/line/LineTrashAltIcon'
import zIndex from 'styles/tools/z-index'
import LinePlusIcon from 'components/Luxkit/Icons/line/LinePlusIcon'
import { tileDesktopLayout } from './constants'

const Container = styled(Group)`
  grid-area: secondary-content;
  
  ${tileDesktopLayout} {
    padding: ${rem(20)};
    flex-direction: column;
  }
`

const StyledButtonsContainer = styled.div`
  z-index: ${zIndex.reviewCartButtons};
  display: flex;
  justify-content: start;
  column-gap: ${rem(8)};

  ${tileDesktopLayout} {
    justify-content: end;
  }
`

interface Props {
  price?: ReactNode
  isBookable: boolean
  saveForLater: boolean
  deleted: boolean
  onSaveForLater?: React.MouseEventHandler<HTMLButtonElement>
  onDelete?: React.MouseEventHandler<HTMLButtonElement>
}

function CartReviewTileSecondaryContent({
  price,
  isBookable,
  saveForLater,
  deleted,
  onSaveForLater,
  onDelete,
}: Props) {
  return (
    <Container
      direction="vertical-reverse"
      tabletDirection="vertical"
      verticalAlign="space-between"
      gap={16}
      tabletGap={24}
    >
      <StyledButtonsContainer>
        {isBookable && !saveForLater && (
          <TextButton
            kind="secondary"
            size="small"
            onClick={onSaveForLater}
          >
            Save for later
          </TextButton>
        )}
        {isBookable && (!deleted && saveForLater) && (
          <TextButton
            kind="primary"
            size="small"
            startIcon={<LinePlusIcon />}
            onClick={onSaveForLater}
          >
            Add
          </TextButton>
        )}
        <TextButton
          kind="secondary"
          size="small"
          startIcon={<LineTrashAltIcon />}
          onClick={onDelete}
        >
          Delete
        </TextButton>
      </StyledButtonsContainer>
      {isBookable && price}
    </Container>
  )
}

export default CartReviewTileSecondaryContent
